import {translate} from '../../../../Translate';
import moment from 'moment';

const predefinedOptionsConfigs = [
  {
    key: 'OneHourBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.OneHourBefore'),
    code: '1hb',
    converter: (value) => moment.utc(value).subtract(1, 'hour').toISOString(),
  },
  {
    key: 'TwoHoursBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.TwoHoursBefore'),
    code: '2hb',
    converter: (value) => moment.utc(value).subtract(2, 'hours').toISOString(),
  },
  {
    key: 'ThreeHoursBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.ThreeHoursBefore'),
    code: '3hb',
    converter: (value) => moment.utc(value).subtract(3, 'hours').toISOString(),
  },
  {
    key: 'FourHoursBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.FourHoursBefore'),
    code: '4hb',
    converter: (value) => moment.utc(value).subtract(4, 'hours').toISOString(),
  },
  {
    key: 'SixHoursBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.SixHoursBefore'),
    code: '6hb',
    converter: (value) => moment.utc(value).subtract(6, 'hours').toISOString(),
  },
  {
    key: 'TwelveHoursBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.TwelveHoursBefore'),
    code: '12hb',
    converter: (value) => moment.utc(value).subtract(12, 'hours').toISOString(),
  },
  {
    key: 'OneDayBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.OneDayBefore'),
    code: '1db',
    converter: (value) => moment.utc(value).subtract(1, 'day').toISOString(),
  },
  {
    key: 'TwoDaysBefore',
    label: translate('tasks.Common.ReminderPicker.PredefinedOptions.Options.TwoDaysBefore'),
    code: '2db',
    converter: (value) => moment.utc(value).subtract(2, 'days').toISOString(),
  },
];

export default predefinedOptionsConfigs;
